// src/features/discovery/components/ConstraintsWizard.jsx
import React from "react";

const BUDGETS = ["<$100k", "$100k–$500k", "$500k–$2M", ">$2M"];
const TIMELINES = ["< 3 months", "3–6 months", "6–12 months", "> 12 months"];
const INTEGRATIONS = ["HR", "Finance", "CRM", "Case Mgmt", "Data Lake", "External API"];
const DATA_CLASSES = ["Public", "PII", "PHI", "Controlled"];

export default function ConstraintsWizard({ value, onChange }) {
  const v = value || {};
  const toggleIntegration = (name) => {
    const set = new Set(v.integrations || []);
    set.has(name) ? set.delete(name) : set.add(name);
    onChange?.({ ...v, integrations: Array.from(set) });
  };

  return (
    <div style={{
      background: 'var(--cares-surface-card)',
      borderRadius: '16px',
      padding: '24px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      border: '1px solid var(--cares-line-card)',
      marginBottom: '24px'
    }}>
      <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: 'var(--cares-text-1)', marginBottom: '16px' }}>
        ⚙️ Constraints
      </h3>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px' }}>
        <label style={{ display: 'block' }}>
          <span style={{ fontSize: '13px', fontWeight: '600', color: 'var(--cares-text-3)', display: 'block', marginBottom: '6px' }}>
            Timeline
          </span>
          <select
            style={{
              width: '100%',
              padding: '10px 12px',
              borderRadius: '8px',
              border: '1px solid var(--cares-line-strong)',
              fontSize: '14px',
              backgroundColor: 'var(--cares-surface-card)'
            }}
            value={v.timeline || ""}
            onChange={(e) => onChange?.({ ...v, timeline: e.target.value })}
          >
            <option value="">Select...</option>
            {TIMELINES.map((t) => (
              <option key={t} value={t}>{t}</option>
            ))}
          </select>
        </label>

        <label style={{ display: 'block' }}>
          <span style={{ fontSize: '13px', fontWeight: '600', color: 'var(--cares-text-3)', display: 'block', marginBottom: '6px' }}>
            Budget
          </span>
          <select
            style={{
              width: '100%',
              padding: '10px 12px',
              borderRadius: '8px',
              border: '1px solid var(--cares-line-strong)',
              fontSize: '14px',
              backgroundColor: 'var(--cares-surface-card)'
            }}
            value={v.budget || ""}
            onChange={(e) => onChange?.({ ...v, budget: e.target.value })}
          >
            <option value="">Select...</option>
            {BUDGETS.map((b) => (
              <option key={b} value={b}>{b}</option>
            ))}
          </select>
        </label>

        <label style={{ display: 'block' }}>
          <span style={{ fontSize: '13px', fontWeight: '600', color: 'var(--cares-text-3)', display: 'block', marginBottom: '6px' }}>
            Data Sensitivity
          </span>
          <select
            style={{
              width: '100%',
              padding: '10px 12px',
              borderRadius: '8px',
              border: '1px solid var(--cares-line-strong)',
              fontSize: '14px',
              backgroundColor: 'var(--cares-surface-card)'
            }}
            value={v.dataClass || ""}
            onChange={(e) => onChange?.({ ...v, dataClass: e.target.value })}
          >
            <option value="">Select...</option>
            {DATA_CLASSES.map((c) => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
        </label>
      </div>

      <div style={{ marginTop: '16px' }}>
        <span style={{ fontSize: '13px', fontWeight: '600', color: 'var(--cares-text-3)', display: 'block', marginBottom: '8px' }}>
          Integration Surfaces
        </span>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '8px' }}>
          {INTEGRATIONS.map((name) => (
            <label key={name} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={v.integrations?.includes(name) || false}
                onChange={() => toggleIntegration(name)}
                style={{ width: '16px', height: '16px' }}
              />
              <span>{name}</span>
            </label>
          ))}
        </div>
      </div>

      <div style={{ marginTop: '16px' }}>
        <label style={{ display: 'block' }}>
          <span style={{ fontSize: '13px', fontWeight: '600', color: 'var(--cares-text-3)', display: 'block', marginBottom: '6px' }}>
            Additional Notes
          </span>
          <textarea
            style={{
              width: '100%',
              padding: '10px 12px',
              borderRadius: '8px',
              border: '1px solid var(--cares-line-strong)',
              fontSize: '14px',
              backgroundColor: 'var(--cares-surface-card)',
              fontFamily: 'inherit',
              resize: 'vertical'
            }}
            rows={3}
            placeholder="Additional objectives or constraints..."
            value={v.notes || ""}
            onChange={(e) => onChange?.({ ...v, notes: e.target.value })}
          />
        </label>
      </div>
    </div>
  );
}
